import { Component, HostListener, ChangeDetectorRef, Renderer2, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BaseAuthService } from "projects/core/app/services/abstracts/auth.service";
import { NotificationService } from "projects/core/app/services/notification.service";
import { OverlayService } from "projects/core/app/services/overlay.service";
import { PushUpdatesService } from "projects/core/app/services/push-updates.service";
import { FADE_IN_ANIMATION } from "projects/core/app/utils/animations";
import { SHARED } from "projects/core/app/shared";
import { NavigationService } from "projects/core/app/services/navigation.service";
import { CacheService } from "projects/core/app/services/cache.service";
import { PatientMainComponent } from "./components/main/main.component";
import { BaseSessionService } from "projects/core/app/services/abstracts/session.service";
import { NotificationComponent } from "projects/core/app/components/notification/notification.component";
import { BaseAppComponent } from "projects/core/app/components/abstracts/app/app.component";
import { environment } from "projects/core/environments/environment";
import { DOCUMENT } from "@angular/common";

const { HOST_ZONE } = environment;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: true,
  imports: [NotificationComponent, SHARED, PatientMainComponent],
  animations: [FADE_IN_ANIMATION],
  providers: [{ provide: Document, useValue: document }],
})
export class PatientAppComponent extends BaseAppComponent {
  @HostListener("window:message", ["$event"]) async onMessage(event) {
    // Used when the patient app is being shown in an iframe so we can logout before changing to a different portal/user
    // Sandbox and production use dentally.com domains (e.g. portal.dentally.com) and other stages use stage-manage.sandbox.portal.dental
    if ((event.origin.endsWith(`.${HOST_ZONE}`) || event.origin.endsWith(".dentally.com")) && event.data === "signout") {
      await this._sessionService.logout();
    }
  }

  constructor(
    protected _router: Router,
    protected _authService: BaseAuthService,
    protected _activatedRoute: ActivatedRoute,
    protected _overlayService: OverlayService,
    protected _changeDetectorRef: ChangeDetectorRef,
    protected _renderer: Renderer2,
    protected _pushUpdatesService: PushUpdatesService,
    protected _notificationService: NotificationService,
    protected _navigationService: NavigationService,
    protected _cacheService: CacheService,
    protected _sessionService: BaseSessionService,
    @Inject(DOCUMENT) protected _document: Document
  ) {
    super(
      _router,
      _authService,
      _activatedRoute,
      _overlayService,
      _changeDetectorRef,
      _renderer,
      _pushUpdatesService,
      _notificationService,
      _navigationService,
      _cacheService,
      _sessionService,
      _document
    );
  }

  override ngOnInit() {
    super.ngOnInit();
    if (environment.FEATURE_FLAG_RECAPTCHA === "true") {
      this._addGoogleRecaptchaScript();
    }
  }

  private _addGoogleRecaptchaScript() {
    const script = this._document.createElement("script");
    const head = this._document.getElementsByTagName("head")[0];

    script.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=${environment.GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    head.appendChild(script);
  }
}
